import { createSelector } from 'reselect';
import { DAYS_PARAM } from 'common/constants/constants';
import _ from 'lodash';
import moment from 'moment';

const getOrganization = state => state.organization;

export const licenseSelector = createSelector(getOrganization, organization =>
  organization
    ? {
        isPaid: _.get(organization, 'license.plan_tier_type', null) === 'paid',
        isTrial:
          _.get(organization, 'license.plan_tier_type', null) === 'trial',
        daysLeftOnTrial:
          moment(_.get(organization, 'license.end_date')).diff(
            moment(),
            DAYS_PARAM
          ) + 1,
        maxRepos: _.get(organization, 'license.max_repos', null),
        maxContributors: _.get(organization, 'license.max_contributors', null),
        maxUsers: _.get(organization, 'license.max_users', null),
        maxBoards: _.get(organization, 'license.max_boards', null),
        maxProjects: _.get(organization, 'license.max_projects', null),
        licenseType: _.get(organization, 'license.plan_tier_type', null),
        retentionDays: _.get(organization, 'license.retention_days', null),
        maxDashboards: _.get(
          organization,
          'license.max_custom_dashboards',
          null
        ),
        startDate: _.get(organization, 'license.start_date', null),
        reposLeft: _.get(organization, 'license.repos_left', null),
        backfillDays: _.get(organization, 'license.backfill_days', null),
        planName: _.get(organization, 'license.plan_name', null)
      }
    : {}
);
/* istanbul ignore next */
export const retentionDaysSelector = createSelector(
  licenseSelector,
  ({ retentionDays }) => retentionDays
);
export const isTeamLicenseSelector = createSelector(
  [getOrganization],
  organization => _.get(organization, 'license.plan_tier_type', '') === 'team'
);
